<style lang="stylus" scoped>
@import '../cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-title {
  margin-bottom: 16px;
  height: auto;
  border-radius: 5px;
}

.map-data {
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>
<template>
  <div class="home-main">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="map-search">
      <div class="map-title">
        <el-row>
          <el-col :span="12">
            <div>
              <span class="color2 pointer" @click="utype!=2?goBack(-1):''">全国</span>
              <span>></span>
              <span>{{provinceName}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="t-r">
              <el-date-picker
                :clearable="false"
                v-model="timeSection"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <!-- -->
              <el-button v-show="hideExport" style="margin-left:20px;" @click="exportDate">导出</el-button>
               
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <TableDate :allData="tableDatas"/> -->
    <template v-for="(item,index) in allData">
      <TableDate
        :allData="item"
        :key="index"
        :name="item.areaName"
        :code="item.cityCode"
        :toDetail="toDetail"
      />
    </template>
  </div>
</template>
<script>
import http from '@/api/consump.js' //请求汇总
import TableDate from '../components/initDate' //表格数据
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
export default {
  data() {
    return {
      hideExport:hideExport,
      mark: false, //遮罩层开关
      timeSection: [
        new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 0 * 24 * 3600 * 1000) * 1
      ],
      progressNum: 0, //下载进度条进度
      provinceName: null,
      provinceCode: null,
      tableDatas: [],
      allData: [],
      utype:0
    }
  },
  created() {
    this.provinceName = decodeURIComponent(this.$route.query.provinceName)
    this.provinceCode = decodeURIComponent(this.$route.query.provinceCode)
    if(this.$route.query.times){
      this.timeSection = JSON.parse(this.$route.query.times)
    }else{
      this.init()
    }
  },
  mounted() {
    this.utype = Cookies.get('userType');
  },
  watch: {
    timeSection: function() {
      this.init()
    }
  },
  methods: {
    init() {
      let that = this
      http.allCard({
          timeSection: that.timeSection,
          provinceCode: that.provinceCode,
          type:2
      }).then(e => {
        that.allData = [...e.data]
      })
      // that.initCity()
    },
    initCity() {
      let that = this
      http.provCard({
        timeSection: that.timeSection,
        provinceCode: this.provinceCode
      }).then(e => {
        that.allData = [...e.data]
      })
    },
    exportDate() {
      //导出
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      let times
      times = setInterval(function() {
        http.progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      window.location.assign(
        http.cityData({
          start: that.timeSection[0],
          end: that.timeSection[1],
          provinceCode: that.provinceCode,
          reqId
        })
      )
    },
    goBack(num) {
      this.$router.go(num)
    },
    toDetail({ name, code }) {
      if(code==null||name=='合计') return false;
      let that = this
      this.$router.push({
        name: 'conCardDot',
        query: {
          times: JSON.stringify(that.timeSection),
          cityName: name,
          cityCode: code,
          provinceName: this.provinceName
        }
      })
    }
  },
  components: {
    TableDate
  }
}
</script>

